
// Import navigation item groups
import dashboardItems from './nav-groups/dashboardItems';
import leadsItems from './nav-groups/leadsItems';
import customersItems from './nav-groups/customersItems';
import chatItems from './nav-groups/chatItems';
import dialerItems from './nav-groups/dialerItems';
import emailItems from './nav-groups/emailItems';
import campaignItems from './nav-groups/campaignItems';
import agentItems from './nav-groups/agentItems';
import ivrItems from './nav-groups/ivrItems';
import toolsItems from './nav-groups/toolsItems';
import reportsItems from './nav-groups/reportsItems';
import helpItems from './nav-groups/helpItems';
import { NavItem } from './types';

// Combine all navigation items with Help at the very bottom
const navItems: NavItem[] = [
  ...dashboardItems,
  ...leadsItems,
  ...customersItems,
  ...chatItems,
  ...dialerItems,
  ...emailItems,
  ...campaignItems,
  ...agentItems,
  ...ivrItems,
  ...toolsItems,
  ...reportsItems,
  ...helpItems,
];

export default navItems;
